import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {withStyles} from '@material-ui/core/styles/index';
import {withRouter} from "react-router-dom";
import {Typography} from '@material-ui/core';
import ReduxMission from '../../../../../store/actionreducers/mission';

class ArchivesTab extends Component {

    componentDidMount() {
        this.props.getArchives(this.props.tempMission.id);
    }

    render() {
        const {archives} = this.props;
        if (archives && archives.length === 0) return (<Typography>查無錄影資料</Typography>);
        return (
            <div>
                {archives.map((ele, index) => (
                    <video src={ele.url} key={index} controls>
                    您的瀏覽器不支援HTML5播放器
                    </video>
                ))}
            </div>
        )
    }
}

const styles = theme => ({
    root: {}
});


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getArchives: ReduxMission.ActionCreator.getArchives,
    }, dispatch);
}
function mapStateToProps({mission: {temp, archives}}) {
    return {
        tempMission: temp,
        archives,
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(ArchivesTab)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/tabs/ArchivesTab.js